import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { HighlightInfo } from '../../common/highlightInfo'
import { selectHighlight, selectLoading } from '../store/slice'
import { getHighLight } from '../store/thunk'

const HIGH_LIGHT_MIN_HEIGHT = 67

export const Highlight = () => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()
  const { currency } = useFormatCurrency(SCREEN.PORTFOLIO_INSIGHTS)

  const locale = useSelector((state) => state.i18n.locale)
  const highlightLoading = useSelector(selectLoading(getHighLight.typePrefix))
  const highlightData = useSelector(selectHighlight)

  useEffect(() => {
    if (!settingParams) return
    dispatch(
      getHighLight({
        ...settingParams,
        currency,
      }),
    )
  }, [settingParams, locale, currency])

  return (
    <HighlightInfo
      highlights={highlightData}
      isLoading={highlightLoading}
      containerStyle={{ minHeight: HIGH_LIGHT_MIN_HEIGHT, marginBottom: 12 }}
    />
  )
}
